import { IconNames } from '@blueprintjs/icons';
import { Button } from '@strata/react-buttons';
import { Dialog } from '@strata/react-dialog';

interface UnsavedChangesDialogProps {
    isOpen: boolean;
    onCancel: () => void;
    onDiscard: () => void;
    onSave: () => Promise<void>;
    isSubmitting?: boolean;
}

export const UnsavedChangesDialog = ({
    isOpen,
    onCancel,
    onDiscard,
    onSave,
    isSubmitting = false,
}: UnsavedChangesDialogProps) => (
    <Dialog
        isOpen={isOpen}
        headerIcon={IconNames.WARNING_SIGN}
        dialogTitle="Unsaved Changes"
        dialogContent="You have unsaved changes. Would you like to save them before continuing?"
        secondaryButtonLabel="Cancel"
        onSecondaryButtonClick={onCancel}
        primaryButtonLabel="Save"
        isPrimaryButtonDisabled={isSubmitting}
        onPrimaryButtonClick={() => {
            (async () => {
                await onSave();
            })();
        }}
        additionalButtons={
            <Button
                intent={Button.Intent.NONE}
                label="Discard"
                id="unsaved-changes-dialog-discard-button"
                onClick={onDiscard}
                disabled={isSubmitting}
            />
        }
    />
);
